up.compiler('[prompt-button]', (element) => {
  const form = element.closest('form')

  up.on(form, 'submit', (evnt) => {
    const input = form.querySelector(`input[name="${element.getAttribute('prompt-input')}"]`)
    
    const inputValue = prompt(element.getAttribute('prompt-button'))
    input.value = inputValue
  })
})